<h5 class="mt-4">Totales Acumulados Caja Permanente:</h5>

<div class="row justify-content-end">
  <div class="col-md-2 col-sm-2 mx-3">
    <mat-form-field>
      <mat-select placeholder="Años Anteriores:" (selectionChange)="selectedPeriodChange($event)"
        [value]="selectedYear">
        <mat-option>Seleccione Un Año</mat-option>
        <mat-option *ngFor="let year of pastYears" [value]="year">
          {{year}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<ng-template #desktopTable>

  <div class="row px-3 mt-4 border-bottom">

    <div class="col-md-3 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
      Fecha:
    </div>

    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">Aportaciones Nómina:
    </div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">Aportaciones
      Extraordinarias:</div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">Retiros Caja De Ahorro:
    </div>
    <div class="col-md-3 d-flex justify-content-center bg-report-header text-white">Total:</div>

  </div>

  <div class="row px-3 border-bottom">

    <div class="col-md-3 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
      {{pastYearsData.text}}
    </div>

    <div class="col-md-2 d-flex border-right justify-content-center bg-report-gray">
      {{pastYearsData.totalContribution ? '$ ' + (pastYearsData.totalContribution | number: '.2-2') : '-'}}</div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-gray">
      {{pastYearsData.totalExtrasContribution ? '$ ' + (pastYearsData.totalExtrasContribution | number: '.2-2') : '-'}}
    </div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-gray">
      {{pastYearsData.totalWithdrawals ? '$ ' + (pastYearsData.totalWithdrawals | number: '.2-2') : '-'}}</div>
    <div class="col-md-3 d-flex border-right justify-content-center bg-report-gray">
      {{pastYearsData.total ? '$ ' + (pastYearsData.total | number: '.2-2') : '-'}}</div>

  </div>

  <div class="row px-3 border-bottom" *ngFor="let item of groupScheduleDatesForDisplay">

    <div class="col-md-3 d-flex border-left border-right align-items-left">{{item.year ? item.year + ' - ' + item.month
      : item.text}}</div>
    <div class="col-md-2 d-flex border-right justify-content-center">
      {{item.totalContribution ? '$ ' + (item.totalContribution | number: '.2-2') : '-'}}</div>
    <div class="col-md-2 d-flex border-right justify-content-center">
      {{item.totalExtrasContribution ? '$ ' + (item.totalExtrasContribution | number: '.2-2') : '-'}}</div>
    <div class="col-md-2 d-flex border-right justify-content-center">
      {{item.totalWithdrawals ? '$ ' + (item.totalWithdrawals | number: '.2-2') : '-'}}</div>
    <div class="col-md-3 d-flex border-right justify-content-center">{{item.total ? '$ ' + (item.total | number: '.2-2')
      : '-'}}</div>

  </div>
  <div class="row px-3 mb-5 border-bottom" *ngIf="selectedYearData ">

    <div class="col-md-3 border-right d-flex align-items-center justify-content-center bg-report-header text-white">
      Total Acumulado Año Vigente:
    </div>

    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">{{
      selectedYearData.yearTotal ? '$ ' + (selectedYearData.yearTotal | number: '.2-2') : '-'}}
    </div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">{{
      selectedYearData.yearTotalExtras ? '$ ' + (selectedYearData.yearTotalExtras | number: '.2-2') : '-'}}</div>
    <div class="col-md-2 d-flex border-right justify-content-center bg-report-header text-white">{{
      selectedYearData.yearTotalWithdrawals ? '$ ' + (selectedYearData.yearTotalWithdrawals | number: '.2-2') : '-'}}
    </div>
    <div class="col-md-3 d-flex justify-content-center bg-report-header text-white">&nbsp;</div>

  </div>

  <div  class="row px-3 mb-5 ">
      <div class="col-md-5 ">
        <div  class="row" *ngFor="let item of totalCurrent">
          <div class="col-md-6 d-flex border-top border-left border-bottom border-right justify-content-left bg-report-header text-white">
           {{item.text}}</div>
         <div class="col-md-5 d-flex border-top border-left border-bottom border-right justify-content-center">{{item.total && item.total > 0 ? '$ ' +
           (item.total | number: '.2-2') : '-'}}</div>
          <div *ngIf="item.note" class="tooltip-main" data-toggle="tooltip" data-placement="top" title="{{item.note}}">
            <span class="tooltip-qm">?</span>
          </div>
        </div>
      </div>
      <div class="col-md-2 d-flex justify-content-center">&nbsp;</div>
      <div class="col-md-5 border-top">
        <div  class="row" *ngFor="let item of totals">
          <div
          class="col-md-6 d-flex border-left border-bottom border-right justify-content-left bg-report-header text-white">
           {{item.text}}</div>
         <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center">{{item.total && item.total > 0 ? '$ ' +
           (item.total | number: '.2-2') : '-'}}</div>

        </div>
        
      </div>
  </div>

<!--inicia nuevo renglon -->
<div  class="row px-3 mb-3">
  <div class="col-md-5 ">
    <div  class="row" *ngFor="let item of totalPrevious">
      <div
      class="col-md-6 d-flex border-top border-left border-bottom border-right justify-content-left bg-report-header text-white">
       {{item.text}}</div>
     <div class="col-md-5 d-flex border-top border-left border-bottom border-right justify-content-center">{{item.total ? '$ ' +
       (item.total | number: '.2-2') : '-'}}</div>
       <div *ngIf="item.note" class="tooltip-main" data-toggle="tooltip" data-placement="top" title="{{item.note}}">
        <span class="tooltip-qm">?</span>
      </div>

    </div>
  </div>
  <div class="col-md-2 d-flex justify-content-center">&nbsp;</div>
  <div class="col-md-5">
    <div  class="row border-top" *ngFor="let item of totalLoan">
      <div
      class="col-md-6 d-flex border-left border-bottom border-right justify-content-left bg-report-header text-white">
       {{item.text}}</div>
     <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center">{{item.total ? '$ ' +
       (item.total | number: '.2-2') : '-'}}</div>

    </div>
    
  </div>
</div>

<div  class="row px-3 mb-5">
  <div class="col-md-5">
    <div  class="row" *ngFor="let item of totalSettlement">
      <div
      class="col-md-6 d-flex border-top border-left border-bottom border-right justify-content-left bg-report-header text-white">
       {{item.text}}</div>
     <div class="col-md-5 d-flex border-top border-left border-bottom border-right justify-content-center">{{item.total ? '$ ' +
       (item.total | number: '.2-2') : '-'}}</div>
       <div *ngIf="item.note" class="tooltip-main" data-toggle="tooltip" data-placement="top" title="{{item.note}}">
        <span class="tooltip-qm">?</span>
      </div>
    </div>
  </div>
</div>
<div class="row px-3 mb-4 border-bottom">
  <div class="col-md-12 bg-report-header text-white d-flex align-items-center justify-content-end">
    <span style="font-size:10pt;">Nota: Los rendimientos están actualizados al dia de hoy y pueden subir o bajar
      diariamente dependiendo de condiciones no sujetas a nuestro control.</span>
  </div>
</div>

<div class="col-md-2 d-flex justify-content-center">&nbsp;</div>
  
  <!-- aqui termina e inicia no se que responsive -->
</ng-template>

<div class="bb-reponsive-table" *ngIf="isHandset$ | async; else desktopTable">
  <div class="bb-resume">
    <div *ngFor="let item of totals">
      <span>{{ item.text }}</span>
      <span>{{item.total ? '$ ' + (item.total | number: '.2-2') : '-'}}</span>
    </div>
  </div>

  <div class="bb-past-years">
    <div class="bb-subtitle">{{pastYearsData.text}}</div>
    <div class="bb-resume">
      <div>
        <span>Aportaciones colaborador:</span>
        <span>{{pastYearsData.totalContribution ? '$ ' + (pastYearsData.totalContribution | number: '.2-2') :
          '-'}}</span>
      </div>
      <div>
        <span>Aportaciones extraordinarias:</span>
        <span>{{pastYearsData.totalExtrasContribution ? '$ ' + (pastYearsData.totalExtrasContribution | number: '.2-2')
          : '-'}}</span>
      </div>
      <div>
        <span>Retiros:</span>
        <span>{{pastYearsData.totalWithdrawals ? '$ ' + (pastYearsData.totalWithdrawals | number: '.2-2') : '-'}}</span>
      </div>
      <div>
        <span>Total:</span>
        <span>{{pastYearsData.total ? '$ ' + (pastYearsData.total | number: '.2-2') : '-'}}</span>
      </div>
    </div>
  </div>

  <div class="bb-period bb-center-text"> Periodo </div>

  <div class="bb-current-year">
    <div *ngFor="let item of groupScheduleDatesForDisplay">
      <div class="bb-subtitle bb-center-text">{{ item.month }}</div>
      <div class="bb-resume">
        <div>
          <span>Aportaciones colaborador:</span>
          <span>{{item.totalContribution ? '$ ' + (item.totalContribution | number: '.2-2') : '-'}}</span>
        </div>
        <div>
          <span>Aportaciones extraordinarias:</span>
          <span>{{item.totalExtrasContribution ? '$ ' + (item.totalExtrasContribution | number: '.2-2') : '-'}}</span>
        </div>
        <div>
          <span>Retiros:</span>
          <span>{{item.totalWithdrawals ? '$ ' + (item.totalWithdrawals | number: '.2-2') : '-'}}</span>
        </div>
        <div>
          <span>Total:</span>
          <span>{{item.total ? '$ ' + (item.total | number: '.2-2') : '-'}}</span>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="row my-5">

  <div class="col-md-4 offset-md-4">
    <button class="btn btn-outline-secondary btn-block" (click)="cancel(0, null)">Regresar</button>
  </div>

  <div class="col-md-4" *ngIf="downloadURLLink; else noLink">
    <a class="btn btn-primary btn-block text-white" [href]="downloadURLLink" target="_blank">Ver Reglamento</a>
  </div>

  <ng-template #noLink>
    <div class="col-md-4">
      <div class="btn btn-primary btn-block text-white">No se ha definido un reglamento</div>
    </div>
  </ng-template>

</div>